




























import { defineComponent, ref } from "@vue/composition-api";
import { BCol, BContainer, BLink, BRow, BTab, BTabs } from "bootstrap-vue";
import ApiKeys from "./apiKeys.vue";
import Webhooks from "./webhooks.vue";

export default defineComponent({
    components: { BRow, BCol, BContainer, BLink, BTabs, BTab, ApiKeys, Webhooks },
    setup() {
        // @todo load tabs via anchors
        const tabIndex = ref(1);

        return {
            tabIndex,
        };
    },
});
